import { Component, OnInit } from '@angular/core';
import {MessageService} from '../../../core/service/message.service';

@Component({
  selector: 'app-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss']
})
export class InfoMessageComponent implements OnInit {
  constructor(public messageService: MessageService) { }

  /**
   *
   */
  ngOnInit(): void {
  }
}
